@if (form) {
  <rask-container-block [formGroup]="form">
    <div class="row">
      <rask-hot-doc
        [hotDoc]="hotDoc">
      </rask-hot-doc>
    </div>
    <div class="row">
      <rask-input-number class="col-1 col-sm-2" label="Maxavvikelse" unit="%" formControlName="langddistributionMaxavvikelse">
      </rask-input-number>
      @if (!viewModel.isMassEditering) {
        <rask-selector
          formControlName="fordelningstyp"
          class="col-2"
          [reverseLookup]="true"
          label="Fördelningstyp"
          [values]="fordelningstyper"
          aid="fordelningstyp">
        </rask-selector>
      }
      @if (!viewModel.isMassEditering) {
        <rask-checkbox
          class="col-2"
          text="Fördelningsaptering"
          formControlName="fordelningsaptering">
        </rask-checkbox>
      }
    </div>
  </rask-container-block>
}
